import TableRow from "@mui/material/TableRow";
import { Box, TableCell } from "@mui/material";
import { useState } from "react";
import CustomIcon from "../common/CustomIcon";
import AppSnackbar from "../common/AppSnackbar";
import AddNewCategoryModal from "./addNewCategoryModal";
import editCategory from "../../../src/assets/icon/editCategory.svg";
import { ColorPallet } from "../../utils/colorPallet";
import usePermissions from "../../hooks/usePermissions";

interface IProps {
  category: any;
  handleOpenModal: () => void;
  setReloadCategory: any;
}

const CategoryInnerRow = ({
  category,
  handleOpenModal,
  setReloadCategory,
}: IProps) => {
  const [openUpdateSnackbar, setOpenUpdateSnackbar] = useState(false);
  const [isUpdateSuccess, setIsUpdateSuccess] = useState(false);
  const [isUpdateError, setIsUpdateError] = useState(false);
  const [updateMessage, setUpdateMessage] = useState("Updated Successfully!");
  const [openEditModal, setOpenEditModal] = useState(false);
  const handleOpenEditModal = () => setOpenEditModal(true);
  const handleCloseEditModal = () => setOpenEditModal(false);
  const isPermissions = usePermissions();
  const Account_Type = parseInt(
    localStorage.getItem("pharmacy_account_type") || "0",
    10
  );

  const handleUpdateSuccess = () => {
    setIsUpdateSuccess(true);
    setIsUpdateError(false);
    setUpdateMessage("Updated Successfully!");
    setOpenUpdateSnackbar(true);
  };

  const handleUpdateError = (message: string) => {
    setIsUpdateSuccess(false);
    setIsUpdateError(true);
    setUpdateMessage(message || "Update Failed!");
    setOpenUpdateSnackbar(true);
  };

  const handleAddError = (message: string) => {
    setIsUpdateSuccess(false);
    setIsUpdateError(true);
    setUpdateMessage(message || "Category Name Already Exists.");
    setOpenUpdateSnackbar(true);
  };

  const commonTableCellStyles = {
    borderRight: `1px solid ${ColorPallet.borderColor}`,
    borderBottom: `1px solid ${ColorPallet.borderColor}`,
    "&.MuiTableCell-root": {
      padding: "5px 0px 5px 15px !important",
    },
  };

  return (
    <>
      <TableRow
        sx={{
          borderTop: `1px solid ${ColorPallet.borderColor}`,
          borderBottom: `1px solid ${ColorPallet.borderColor}`,
        }}
      >
        <TableCell
          sx={{
            ...commonTableCellStyles,
            borderLeft: `1px solid ${ColorPallet.borderColor}`,
          }}
        >
          {category?.name}
        </TableCell>
        <TableCell sx={commonTableCellStyles}>
          {category?.description}
        </TableCell>
        <TableCell sx={commonTableCellStyles}>
          {(Account_Type === 0 ||
            (isPermissions?.edit && Account_Type === 1)) && (
            <Box sx={{ display: "flex", gap: 1 }}>
              <Box sx={{ cursor: "pointer"}}>
                <CustomIcon
                  IconType={editCategory}
                  title="Edit"
                  onClick={handleOpenEditModal}
                />
              </Box>
            </Box>
          )}
        </TableCell>
      </TableRow>

      <AppSnackbar
        message={updateMessage}
        open={openUpdateSnackbar}
        handleClose={() => setOpenUpdateSnackbar(false)}
        severity={isUpdateSuccess ? "success" : "error"}
      />

      {openEditModal && (
        <AddNewCategoryModal
          handleClose={handleCloseEditModal}
          isEdit={true}
          initialData={category}
          setReloadCategory={setReloadCategory}
          onUpdateSuccess={handleUpdateSuccess}
          onUpdateError={handleUpdateError}
          onAddError={handleAddError}
        />
      )}
    </>
  );
};

export default CategoryInnerRow;
